import { Page, PageTitleWithButton } from '../../../components';
import { Box, Button, List, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { IPartClass } from '../../../models/part-classes';
import { useQuery } from 'react-query';
import { getPartClasses } from '../../../fetch/manage-part-classes';
import { useState } from 'react';
import { PartClassItem } from './manage-part-class-list';
import { ManagePartClassFilter } from './manage-part-class-filter';
import { Add } from '@mui/icons-material';

export const ManagePartClasses = () => {
  const classes = useStyles();
  const [hasAppliedFilters, setHasAppliedFilters] = useState<boolean>(false);
  const [searchValue, setSearch] = useState<string>('');
  const [filters, setFilters] = useState<{
    search?: string;
  } | null>({});

  const { isLoading, data: partClassesData } = useQuery<IPartClass[], Error>(
    ['getPartClasses', filters.search],
    () => getPartClasses({ name: searchValue }),
    {
      onError: error => console.log(error)
    }
  );

  return (
    <Page title="Manage Part Classes">
      <PageTitleWithButton
        pageTitleProps={{
          title: 'Manage Part Classes'
        }}
        button={
          <Button
            startIcon={<Add />}
            onClick={() => alert('Add new Part Class')}
            color="primary"
            variant="contained"
          >
            Add
          </Button>
        }
      />
      <Box mt={1}>
        <ManagePartClassFilter
          isLoading={isLoading}
          setHasAppliedFilters={setHasAppliedFilters}
          hasAppliedFilters={hasAppliedFilters}
          setSearchValue={setSearch}
          searchValue={searchValue}
          handleSearch={(val: string) => {
            setFilters({
              ...filters,
              search: val
            });
          }}
          applyFilters={(clearFilters?: boolean, clearSearch?: boolean) => {
            if (clearFilters) {
              setFilters({
                search: ''
              });
            } else {
              setFilters({
                ...filters,
                search: searchValue
              });
            }
          }}
        />
      </Box>
      <List component="div" aria-labelledby="nested-list-subheader" className={classes.list}>
        {partClassesData?.map((partClass, index) => {
          return <PartClassItem key={partClass.partClassId} index={index} partClass={partClass} />;
        })}
      </List>
    </Page>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  list: {
    maxHeight: `30rem`,
    overflow: 'auto',
    margin: theme.spacing(1, 0)
  }
}));
